// extracted by mini-css-extract-plugin
export default {"secondary-text":"lQOVGNZ5bxbzjGeXo3Gg"};